var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":true,"can-cancel":false,"is-full-page":_vm.isFullPage}})}
var staticRenderFns = []

export { render, staticRenderFns }